import './Main.scoped.scss'
import RedirectActionForm from 'FlowBuilder/components/ActionForms/RedirectActionForm'
import ShareActionForm from 'FlowBuilder/components/ActionForms/ShareActionForm'
import LundaActionForm from 'FlowBuilder/components/ActionForms/LundaActionForm'
import FundraiseUpActionForm from './ActionForms/FundraiseUpActionForm'
import EmailToTargetActionForm from './ActionForms/EmailToTargetActionForm'
import SurveyActionForm from 'FlowBuilder/components/ActionForms/SurveyActionForm'
import DonateActionForm from './ActionForms/DonateActionForm'
import CustomActionForm from './ActionForms/CustomActionForm'
import UnsavedActionForm from './ActionForms/UnsavedActionForm'

import Setup from './Setup'

import Template from './Template'

import RedirectActionView from './ActionViews/Redirect/RedirectActionView'
import Preview2 from './ActionViews/Preview2'

export default function Main() {
  const navItem = useSel(s => s.local.navItem)
  const selectedActionId = useSel(s => s.local.selectedActionId)
  const selectedAction = useSel(s => s.actions.entities[selectedActionId])
  const selectedActionKind = selectedAction?.kind
  const isDirty = useSel(s => s.local.isDirty)

  // Redirect we just render a static piece of info
  const showPreview = navItem === 'preview' && selectedActionKind !== 'redirect'

  return <>
    { navItem === 'template' && <Template /> }
    { navItem === 'setup' && <Setup /> }
    { navItem === 'build' && <Build /> }

    {/* This stays always mounted so we don't have a wait for preview to load when tabbing */}
    <div className={`preview-wrapper ${showPreview ? 'visible' : ''}`}>
      {selectedActionKind === 'email_to_target' && isDirty &&
        <div className='alert'>Changes to templates or recipients won't display here until you save.</div>
      }
      <Preview2 />
    </div>
    { navItem === 'preview' && selectedActionKind === 'redirect' && <RedirectActionView /> }
  </>
}

function Build() {
  const selectedActionId = useSel(s => s.local.selectedActionId)
  const selectedPageNumber = useSel(s => s.local.selectedPageNumber)
  const selectedAction = useSel(s => s.actions.entities[selectedActionId])
  const selectedActionKind = selectedAction?.kind

  if (selectedAction) {
    if (selectedAction.id && String(selectedAction.id).includes('-')) {
      return <UnsavedActionForm />
    }
    switch (selectedActionKind) {
      case 'redirect':
        return <RedirectActionForm actionId={selectedActionId} />
      case 'share':
        return <ShareActionForm actionId={selectedActionId} />
      case 'lunda':
        return <LundaActionForm actionId={selectedActionId} />
      case 'fundraise_up':
        return <FundraiseUpActionForm actionId={selectedActionId} />
      case 'email_to_target':
        return <EmailToTargetActionForm actionId={selectedActionId} />
      case 'survey':
        return <SurveyActionForm actionId={selectedActionId} pageNumber={selectedPageNumber} />
      case 'donate':
        return <DonateActionForm actionId={selectedActionId} />
      case 'custom':
        return <CustomActionForm actionId={selectedActionId} />
      default:
        return <div>Unknown action kind: {selectedAction.kind}</div>
    }
  }

  return null
}
